export interface ConfigData {
  apiUrl: string;
}

export class ConfigService {
  constructor(private readonly config: ConfigData) {}

  get apiUrl(): string | undefined {
    return this.config.apiUrl;
  }
}
